module.exports = __webpack_public_path__ + "img/43_49.fc013e53.png";